export default __webpack_public_path__ + "static/media/whyUseSmartApyUsdxx.b952b5f8.svg";